export default "__VITE_ASSET__e1368ded__"